import { RootLayout } from "../../layout";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import "./styles.css";
import { useEffect, useState } from "react";
import { ModalAcessoEstabelecimento } from "./modulos/ModalAcessoEstabelecimento";
import { ModalAcessoProfissional } from "./modulos/ModalAcessoProfissional";
import api from "../../services/api";
import ModalDialogs from "../../components/ModalDialogs";
import { getItemDecrypt } from "../../utils/cryptoData";
import CircularProgress from "@mui/material/CircularProgress";
import { Stack } from "@mui/material";

export default function GerenciamentoAcesso() {
  const [refresh, setRefresh] = useState(false);
  const [openModal1, setOpenModal1] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [tipoConsentimento, setTipoConsentimento] = useState(1);
  const [estabelecimentosAdicionados, setEstabelecimentosAdicionados] =
    useState([]);
  const [profissionaisAdicionados, setProfissionaisAdicionados] = useState([]);
  const [modalError, setModalError] = useState({
    open: false,
    message: "",
  });
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleRefresh = (value) => setRefresh(value);

  const id = getItemDecrypt("paciente");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await api.get(`/consentimento/${id}`);
      setTipoConsentimento(response.data.tipoConsentimento);
      setEstabelecimentosAdicionados(response.data.estabelecimentos);
      setProfissionaisAdicionados(response.data.profissionais);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      const response = await api.post(`/consentimento/`, {
        data: {
          id_paciente: id,
          co_tipo_consentimento: tipoConsentimento,
          estabelecimentos:
            tipoConsentimento === 3 ? [] : estabelecimentosAdicionados,
          profissionais:
            tipoConsentimento === 3 ? [] : profissionaisAdicionados,
        },
      });

      if (response.data.hasOwnProperty("error")) {
        setModalError({
          open: true,
          message: response.data.message,
        });
        console.error(response);
      }
      setOpenSuccessModal(true);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <RootLayout>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <div className="corpo-acessos">
            <div className="politicas-acesso">
              <div>
                <p className="titulo-politicas">Políticas de Acesso</p>
                <p className="corpo-texto-politicas">
                  Defina as diretrizes para autorização de acesso ao seus dados
                  de saúde
                </p>
              </div>

              <div className="seletor-acesso">
                <label
                  style={{ cursor: "pointer" }}
                  htmlFor="consentimento-geral"
                >
                  <p className="tipos-politica">Consentimento geral de dados</p>
                  <p className="corpo-texto">
                    Compartilhar meus dados de saúde com todos os profissionais
                    que possuem acesso ao PEP ELA
                  </p>
                </label>
                <input
                  id="consentimento-geral"
                  className="input-radio"
                  type="radio"
                  value={1}
                  checked={tipoConsentimento === 1}
                  onChange={(event) =>
                    setTipoConsentimento(Number(event.target.value))
                  }
                />
              </div>

              <div className="box-especifico">
                <label
                  style={{ cursor: "pointer", background: "transparent" }}
                  htmlFor="consentimento-especifico"
                  className="seletor-acesso-especifico"
                >
                  <p className="tipos-politica">Consentimento específico</p>
                  <input
                    id="consentimento-especifico"
                    className="input-radio"
                    type="radio"
                    value={2}
                    checked={tipoConsentimento === 2}
                    onChange={(event) =>
                      setTipoConsentimento(Number(event.target.value))
                    }
                  />
                </label>

                <div className="corpo-consent-espec">
                  <div>
                    <p className="tipo-especifico">Estabelecimento de saúde</p>
                    <p className="corpo-texto">
                      Compartilhar meus dados de saúde com apenas profissionais
                      de um estabelecimento de saúde autorizados por mim e que
                      possua acesso ao PEP ELA
                    </p>
                    {tipoConsentimento === 2 && (
                      <ModalAcessoEstabelecimento
                        openModal={openModal1}
                        setOpenModal={setOpenModal1}
                        setRefresh={handleRefresh}
                        refresh={refresh}
                        modalHeaderText="Adicionar estabelecimento"
                        estabelecimentosAdicionados={
                          estabelecimentosAdicionados
                        }
                        setEstabelecimentosAdicionados={
                          setEstabelecimentosAdicionados
                        }
                      />
                    )}
                  </div>

                  <div className="divisao-especifico" />

                  <div>
                    <p className="tipo-especifico">Profissionais</p>
                    <p className="corpo-texto">
                      Compartilhar meus dados de saúde com profissionais
                      específicos autorizados por mim e que possuam acesso ao
                      PEP ELA
                    </p>
                    {tipoConsentimento === 2 && (
                      <ModalAcessoProfissional
                        openModal={openModal2}
                        setOpenModal={setOpenModal2}
                        setRefresh={handleRefresh}
                        refresh={refresh}
                        modalHeaderText="Adicionar profissional"
                        profissionaisAdicionados={profissionaisAdicionados}
                        setProfissionaisAdicionados={
                          setProfissionaisAdicionados
                        }
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="seletor-acesso">
                <label
                  style={{ cursor: "pointer" }}
                  htmlFor="nao-consentimento"
                >
                  <p className="tipos-politica">Não consentimento</p>
                  <p className="corpo-texto">
                    Compartilhar meus dados de saúde com nenhum profissional que
                    possua acesso ao Conecte SUS Profissional
                  </p>
                </label>
                <input
                  id="nao-consentimento"
                  className="input-radio"
                  type="radio"
                  value={3}
                  style={{
                    color: "red",
                    outline: "red",
                    backdropFilter: "red",
                    backgroundColor: "red",
                  }}
                  checked={tipoConsentimento === 3}
                  onChange={(event) =>
                    setTipoConsentimento(Number(event.target.value))
                  }
                />
              </div>

              <Stack mt={2} alignItems="flex-end">
                <Button
                  disabled={isLoading}
                  type="button"
                  onClick={() => handleSubmit()}
                  variant="contained"
                  startIcon={
                    isLoading && <CircularProgress color="inherit" size={20} />
                  }
                  sx={{
                    width: "fit-content",
                    textTransform: "capitalize",
                  }}
                >
                  Salvar
                </Button>
              </Stack>
            </div>
          </div>
        </Box>
      </RootLayout>

      <ModalDialogs
        open={modalError.open}
        onClose={() => setModalError({ open: false, message: "" })}
        onActionPrimary={() => setModalError({ open: false, message: "" })}
        modalType="error"
        title="Error"
        body={modalError.message}
        primaryButtonText="Fechar"
      />
      <ModalDialogs
        open={openSuccessModal}
        onClose={() => setOpenSuccessModal(false)}
        title="Sucesso"
        modalType="success"
        body={
          <Box sx={{ width: { xs: "100%", sm: "400px" } }}>
            <Box>Consentimento salvo com sucesso</Box>
          </Box>
        }
      />
    </Box>
  );
}
